export default __webpack_public_path__ + "static/media/google_trends.df51297d.png";